import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/all-bookings-view/components/AllBookingsInteractive.tsx");
